module.exports = __webpack_public_path__ + "static/media/f_eyeshape_almond_amber.e5e98cfa.png";